















import {
	Component,
	Vue
} from "vue-property-decorator";
import {
	Button
} from "vant";
import {
	jumpLink
} from "@/utils/hybirdMethods";
import {
	getBrowser
} from "@/utils/browser";
const browser = getBrowser();
@Component({
	name: "MResult",
	components: {
		[Button.name]: Button
	}
})
export default class MResult extends Vue {
	email: any = ""
	activated(){
		const userInfo = (this as any).$localstorage.get("userInfo") || {};
		(this as any).email = userInfo.email;
	}
	overclose() {
		if (browser.isApp) {
			jumpLink("refresh_user");

		} else {
			(this as any).$router.push("/");

		}
	}
}
